export default __webpack_public_path__ + "static/media/demo-3.28154229.png";